import React from 'react';
import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ChartCard = ({ title, description, type, data, options }) => {
  const ChartComponent = type === 'doughnut' ? Doughnut : Bar;

  return (
    <div className="card">
      <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
        {title}
      </h3>
      {description && (
        <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#cbd5e1' }}>
          {description}
        </p>
      )}
      <div className="chart-container">
        <ChartComponent data={data} options={options} />
      </div>
    </div>
  );
};

export default ChartCard;
